import { StandardButton } from "../atoms/buttons"
import { icon } from "../functions/icons"
import { HorizontalLayout, VerticalLayout } from "./layout"
import { Modal, ModalBody, ModalFooter, ModalTitle } from "./modal"

export const CourseModal = ({ course, onClose, addCourse, visible, selected }) => {
    return (
        <Modal visible={visible} dismissable={onClose}>
            <ModalTitle
                dismissable={onClose}
                hasXmark={true}
                title={course?.title || "Course Title"}
            />
            <ModalBody>

                <img style={{ height: "15rem", objectFit: "cover", width: "100%" }} src={course?.image_url || "https://via.placeholder.com/150"} alt={course?.title} className="course-image" />

                <HorizontalLayout className="course-modal-content" style={{ marginTop: '1rem', marginBottom: '1rem', alignItems: "unset" }}>
                    {icon("book-shelf", "2rem", "var(--primary-600)")}
                    <VerticalLayout className="course-title-row" style={{ marginLeft: "1rem", width: "80%" }} >

                        <p className="course-title" style={{ marginBottom: '0.5rem' }} >
                            Over deze e-learning
                        </p>
                        <p className="course-description">

                            {course?.description || "Course description goes here."}</p>
                    </VerticalLayout>


                </HorizontalLayout>

            </ModalBody>
            <ModalFooter style={{
                borderColor: "rgb(224, 224, 224)",
                paddingTop: "1rem",
                borderTopWidth: "0.5px",
                borderTopStyle: "solid"
            }}>
                <StandardButton
                    title={!selected ? "Selecteer deze cursus" : "Deselecteer deze cursus"}
                    onClick={addCourse}
                />
            </ModalFooter>
        </Modal>
    )
}